import './Results.scss';
import Component from './Results.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
